import {ChangeEvent, memo, useCallback, useEffect, useState} from 'react';
import {Select, Option} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";

export interface FooterListItem {
    name: string | number,
    code?: string,
    id?: number,
    icon?: JSX.Element,
    value?: string | number,
    data?: unknown
}

interface FooterMenuProps {
    selected: string | number,
    list: FooterListItem[],
    icon?: JSX.Element,
    onClick: (s: string | number) => void,
    className?: string,
    buttonClassName?: string,
    id?: string,
    searchable?: boolean,
    withAllElement?: boolean,
    selectorClassName?: string
}

const FooterMenu = ({
                        icon,
                        list,
                        selected,
                        onClick,
                        className,
                        buttonClassName,
                        selectorClassName,
                        id,
                        searchable = false,
                        withAllElement = false
                    }: FooterMenuProps) => {
    const {t} = useTranslation();
    const addAllElement = useCallback((l: FooterListItem[]) => {
        if (withAllElement) {
            return [{
                name: 'All',
                code: '0',
                icon: <></>
            }, ...l];
        }
        return l;
    }, [withAllElement]);
    const [localList, setLocalList] = useState<FooterListItem[]>([]);
    const [search, setSearch] = useState<string>('');
    const setSearchInputRef = useCallback((node: HTMLInputElement | null) => {
        if (node && searchable) {
            setTimeout(function(){
                node.focus({preventScroll: true});
            }, 300);
        }
    }, [searchable]);

    const onSearchChanged = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget) {
            const query = e.currentTarget.value.toLowerCase();
            setSearch(e.currentTarget.value);
            setLocalList(addAllElement(list.filter(i => i.name.toString().toLowerCase().includes(query) || (i.code && i.code.includes(query))).slice(0, 10)));
        }
    }

    useEffect(() => {
        setLocalList(searchable && list.length > 10 ? addAllElement(list.slice(0, 10)) : addAllElement(list));
        if (searchable) {
            setTimeout(() => {
                const searchElement = document.getElementById(`search-input-footer-menu-${id}`);
                if (searchElement) {
                    searchElement.focus()
                }
            }, 300);
        }
    }, [list, addAllElement, id, searchable]);

    const checkHasScrollBar = () => {
        const el = document.getElementsByClassName('page-card-block').item(0);
        if (el && el.scrollHeight > el.clientHeight && !el.classList.contains('is-scrollable')) {
            el.classList.add('is-scrollable');
        } else if (el)
            el.classList.remove('is-scrollable');
    }

    return <div className={`${className ?? ''} w-auto block lg:inline-block`}>
        <Select
            id={id ? '#' + id : ''}
            value={selected.toString()}
            arrow={icon ?? <span className="empty-data"/>}
            className={`button-select z-[999] p-1 w-full lg:w-auto flex items-center border-0 shadow-none hover:shadow-none text-black dark:text-white outline-none ${buttonClassName ?? ''}`}
            labelProps={{
                className: "hidden"
            }}
            menuProps={{
                className: `select-menu-classes ${selectorClassName ?? ''}`,
            }}
            containerProps={{className: 'h-16'}}
            onFocus={() => checkHasScrollBar()}
            onBlur={() => checkHasScrollBar()}
        >
            {searchable ? <input id={`search-input-footer-menu-${id}`}
                                 autoComplete="off"
                                 className="w-full px-3 py-1 rounded border border-gray-700 mb-2 bg-transparent outline-none placeholder:opacity-100 placeholder:text-gray-700"
                                 placeholder={t('admin.datatable.search')}
                                 value={search}
                                 ref={setSearchInputRef}
                                 onKeyDown={(e) => { if (e.key.length === 1) e.stopPropagation(); }}
                                 onChange={onSearchChanged}/> : ''}
            {searchable && list.length > 10 ?
                <div className="text-xs px-2 mb-2 text-gray-700 outline-none">{t('admin.datatable.only_10')}</div> : ''}
            {localList.map(item => {
                const vl = item.id ? item.id.toString() : (item.code?.toString() ?? item.name.toString());
                return (<Option
                    value={vl}
                    onClick={() => onClick(vl)}
                    className={`${item.name === 'All' && item.code === '0' ? 'w-full uppercase font-bold text-[10px] text-center' : ''}`}
                    key={`${item.name.toString()}_${item.id?.toString()}_${item.code}`}>
                    {item.icon}{item.name}
                </Option>);
            })}
        </Select>

        {/*<Menu>*/}
        {/*    <MenuHandler>*/}
        {/*        <div>*/}
        {/*            <Button*/}
        {/*                className={`p-1 w-full lg:w-auto flex items-center border-0 shadow-none hover:shadow-none text-black dark:text-white outline-none ${buttonClassName ?? ''}`}>{icon} {selected}</Button>*/}
        {/*        </div>*/}
        {/*    </MenuHandler>*/}
        {/*    <MenuList*/}
        {/*        className="bg-gray-200 dark:bg-gray-500 dark:text-blue-gray-900 dark:border-blue-gray-900 max-h-[50vh] overflow-y-auto">*/}
        {/*        {searchable && <input id={`search-input-footer-menu-${id}`}*/}
        {/*                              className="w-full px-3 py-1 rounded border border-gray-700 mb-2 bg-transparent outline-none placeholder:opacity-100 placeholder:text-gray-700"*/}
        {/*                              placeholder={t('admin.datatable.search')} value={search}*/}
        {/*                              onChange={onSearchChanged}/>}*/}
        {/*        {searchable && list.length > 10 &&*/}
        {/*            <div className="text-xs px-2 mb-2 text-gray-700 outline-none">{t('admin.datatable.only_10')}</div>}*/}
        {/*        {localList.map(item => <MenuItem*/}
        {/*            key={`${item.name.toString()}_${item.id?.toString()}_${item.code}`}>*/}
        {/*            {item.icon}{item.name}*/}
        {/*        </MenuItem>)}*/}
        {/*    </MenuList>*/}
        {/*</Menu>*/}
    </div>
}

export default memo(FooterMenu);
